//#region redux
//#endregion
//#region types
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
import { SendMailOptions } from "models/formTypes/invoice";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useInvoiceService } from "serviceHooks";
//#endregion
import { UtilsHelper } from "utils/helpers";

function useLoadSendMailOptions() {
  const invoiceService = useInvoiceService();

  const loadSendMailOptions = async (invoiceId?: number, customerId?: number, version?: number) => {
    const res = await invoiceService.getInvoiceMailForm({ customerId: customerId, version: version }, invoiceId);

    let mailFrom: SelectInputItemProps[] = [];

    if (res?.mailFromList) {
      mailFrom = res.mailFromList.map(
        (item): SelectInputItemProps => ({
          value: item.type,
          label: item.address ?? "",
          description: item.name,
          icon:
            item.type === WintSuperkollAPIModel.SendInvoiceMailsFromEnum.PersonMail
              ? IconDefinitionConstants.WUser
              : IconDefinitionConstants.WCompany,
        })
      );
    }

    let mailToList: AutocompleteListItem[] = [];
    if (res?.mailToList) {
      const mails = new Set(res.mailToList.flatMap((item) => UtilsHelper.splitMultipleEmails(item.address)));
      mailToList = Array.from(mails).map((email) => ({
        id: email,
        value: email,
      }));
    }

    const options: SendMailOptions = {
      mailFromList: mailFrom,
      mailToList,
      mailSubject: res?.subject ?? "",
      mailMessage: res?.message ?? "",
      emailFromType: res?.from?.type,
      emailFrom: res?.from?.address,
      defaultEmailTo: {},
    };

    return options;
  };

  return { loadSendMailOptions };
}

export default useLoadSendMailOptions;
